<div>
  <div class="hall-of-fame">
    <div class="inner">
      <h1><img src="/utest-static/assets/images/utestLogo-small-white.png" alt="">Hall of Fame</h1>

      <select [(ngModel)]="search.year" (change)="onYearChange()">
        @for (year of searchOptions.years; track year) {
          <option [value]="year">{{ year }}</option>
        }
      </select>

      <select [(ngModel)]="search.period" (change)="onPeriodChange()">
        @for (period of searchOptions.periods; track period) {
          <option [value]="period">{{ period }}</option>
        }
      </select>
    </div>
  </div>

  <div class="hall-of-fame-content">
    <div class="grid w890">
      @for (pageData of data; track pageData) {
        <div>
          <h2>{{ pageData.title }}</h2>
          <ul>
            @for (user of pageData.winners; track trackByUserId($index, user)) {
              <li>
                <ut-user-card [user]="user"></ut-user-card>
              </li>
            }
          </ul>
        </div>
      }

      @if (isLoading) {
        <ut-loading-dots></ut-loading-dots>
      }
    </div>

    <nav>
      <a [class.invisible]="!next" [uiSref]="'halloffamedate'" [uiParams]="next">Next Quarter</a>
      <a [class.invisible]="!next" [class.up]="true" [uiSref]="'halloffamedate'" [uiParams]="next"></a>
      <a [class.invisible]="!previous" [class.down]="true" [uiSref]="'halloffamedate'" [uiParams]="previous"></a>
      <a [class.invisible]="!previous" [uiSref]="'halloffamedate'" [uiParams]="previous">Previous Quarter</a>
    </nav>
  </div>
</div>
